import Service from "./Service";
const baseurl = '/api/historia-rango-escala-abreviada-desarrollo';
export default {
    index() {

        return Service.get(`${baseurl}`);
    },
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    show(id) {
        return Service.get(`${baseurl}/show/${id}`);
    },
    showByBirthday(fecha_nacimiento) {
        return Service.get(`${baseurl}/show-by-birthday/${fecha_nacimiento}`);
    },
    update(obj) {
        return Service.put(`${baseurl}/update`, obj);
    },
    delete(id) {
        return Service.delete(`${baseurl}/delete/${id}`);
    },
}